import React, { useState } from "react";
import { Button } from "../../../components/UI/button";
import images from "../../../constants/images";
import { LoaderVectors } from "../../../constants/icons";
import { defaultLanguage } from "../../../constants/languages";

export function InputCarrierForm({ popUpText, config, language, setStep }) {
  const [loading, setLoading] = useState(true);

  return (
    <div className="flex flex-col justify-center items-center gap-6">
      {popUpText && (
        <div className="relative bg-[#FFCC00] rounded-lg px-3 py-1">
          <p
            className="text-sm text-center font-semibold"
            dangerouslySetInnerHTML={{ __html: popUpText }}
          ></p>
          <img
            className="pt-[0.5px] absolute left-1/2 -translate-x-1/2"
            src={images.downArrow}
            alt="Yellow Down Arrow"
          />
        </div>
      )}

      <Button
        className={`flex flex-row gap-2 h-[96px] px-5 py-4 w-full mt-2 ${
          loading ? "cursor-not-allowed " : "cursor-pointer "
        }  font-semibold text-lg md:text-2xl rounded-full tracking-wider`}
        style={{
          backgroundColor: config.button_primary || "#e02f1fe3",
          color: config.button_text_color || "#000",
        }}
        type="submit"
        disabled={loading}
      >
        {loading ? (
          <>
            <span className="animate-spin">
              <LoaderVectors />
            </span>
            <div className="flex flex-row justify-end items-center">
              <p className="m-0">Checking</p>
              <span className="animate-bounce">.</span>
              <span className="animate-bounce delay-200">.</span>
              <span className="animate-bounce delay-300">.</span>
            </div>
          </>
        ) : (
          config.texts?.[language || defaultLanguage]?.[1]?.button_text || ""
        )}
      </Button>

      <div className="flex justify-center items-center w-full">
        <span className="text-sm">
          {config.texts?.[language || defaultLanguage]?.[1]?.button_caption ||
            ""}
        </span>
      </div>
    </div>
  );
}
